<template>
    <a href="#" @click.prevent="next()" class="next-section" :style="{color}">
        <span class="floating-bg" :style="{background: color}"></span>
        <span class="title">{{ title }}</span>
        <span class="icon"><i class="dfcicon-angle-down"></i></span>
    </a>
</template>

<script>
import jQuery from "jquery";

export default {
    name: "GoToNextSection",
    props: {
        target: {
            type: [Object, Element, String],
            default: () => null
        },
        title: {
            type: String,
            default: 'Go to next section',
        },
        color: {
            type: String,
            default: '#000',
        }
    },

    methods: {
        next(){

            console.log( this.target );

            if( this.target ){
                $([document.documentElement, document.body]).animate({
                    scrollTop: jQuery(this.target).offset().top
                }, 700);
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.next-section{
    display: inline-block;
    text-decoration: none;
    font-weight: $font-weight-semibold;
    padding: .35rem .8rem .25rem;
    position: relative;
    transition: color .3s;

    &:not(:hover){
        color: $dark !important;
    }

    &:hover{
        text-decoration: none;

        .floating-bg{
            opacity: .1;
        }
    }

    .icon{
        display: block;
        line-height: 1.1rem;
    }

    .floating-bg{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: .3rem;
        opacity: 0;
        transition: opacity .3s;
    }

}
</style>
